import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/modules/account/templates/login-template.tsx");
